import { service } from './service'

import { config } from './config'

const { default_headers } = config

const request = (option: any) => {
  const { url, method, params, data, headersType, responseType, ...config } = option
  const headers: Record<string, string> = {
    'Content-Type': headersType || default_headers
  }
  // 下载/二进制响应：覆盖 axios 默认的 Accept: application/json，
  // 否则后端按 Accept 内容协商返回 JSON，而非文件流（xlsx/csv）
  if (responseType === 'blob' || responseType === 'arraybuffer') {
    headers['Accept'] = '*/*'
  }
  return service({
    url: url,
    method,
    params,
    data,
    ...config,
    responseType: responseType,
    headers
  })
}
export default {
  get: async <T = any>(option: any) => {
    const res = await request({ method: 'GET', ...option })
    return res.data as unknown as T
  },
  post: async <T = any>(option: any) => {
    const res = await request({ method: 'POST', ...option })
    return res.data as unknown as T
  },
  postOriginal: async (option: any) => {
    const res = await request({ method: 'POST', ...option })
    return res
  },
  delete: async <T = any>(option: any) => {
    const res = await request({ method: 'DELETE', ...option })
    return res.data as unknown as T
  },
  put: async <T = any>(option: any) => {
    const res = await request({ method: 'PUT', ...option })
    return res.data as unknown as T
  },
  download: async <T = any>(option: any) => {
    const res = await request({ method: 'GET', responseType: 'blob', ...option })
    return res as unknown as Promise<T>
  },
  upload: async <T = any>(option: any) => {
    option.headersType = 'multipart/form-data'
    const res = await request({ method: 'POST', ...option })
    return res.data as unknown as T
  }
}
